<div class="dialog-container">
  <div class="dialog-header">
    <div class="header-text">
      <div class="title">{{ data.title }}</div>
      @if (data.message) {
        <div class="subtitle">{{ data.message }}</div>
      }
    </div>
  </div>

  <div class="actions-row">
    @for (action of data.actions; track action) {
      <button
        mat-button
        [disabled]="action.disabled"
        (click)="action.action()"
        [ngClass]="action.color === 'primary' ? 'btn-accept' : 'btn-clear'"
        data-test="action-button"
      >
        {{ action.name }}
      </button>
    }
  </div>
</div>
